
import { BaseBackgroundEffect } from '../BaseBackgroundEffect';
import { BackgroundContext } from '../BackgroundEffect';

export class MatrixCodeBackground extends BaseBackgroundEffect {
    private columns: number[] = [];

    private init(bc: BackgroundContext) {
        const charSize = 20;
        const colCount = Math.ceil(bc.width / charSize);
        if (this.columns.length === colCount) return;

        this.columns = [];
        for (let i = 0; i < colCount; i++) {
            this.columns.push(Math.random() * bc.height);
        }
    }

    public render(bc: BackgroundContext): void {
        const { ctx, width, height, time, config } = bc;
        this.init(bc);

        ctx.fillStyle = config.backgroundPrimaryColor;
        ctx.fillRect(0, 0, width, height);

        const charSize = 20;
        const speed = (config.backgroundSpeed || 1.0) * 5;

        ctx.font = '20px monospace';
        ctx.fillStyle = this.getPrimaryColor(bc);

        this.columns.forEach((y, x) => {
            const char = String.fromCharCode(0x30A0 + Math.random() * 96);
            ctx.fillText(char, x * charSize, y);
            
            if (config.backgroundAnimate) {
                this.columns[x] += speed + Math.random() * 2;
                if (this.columns[x] > height) {
                    this.columns[x] = -20;
                }
            }
        });
    }
}
